module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-57x57-bf6b7177020506ba97d57d84004811a2.png";